import { render, staticRenderFns } from "./WeeklyProductCard.vue?vue&type=template&id=2b7b3c86&scoped=true"
import script from "./WeeklyProductCard.vue?vue&type=script&lang=js"
export * from "./WeeklyProductCard.vue?vue&type=script&lang=js"
import style0 from "./WeeklyProductCard.vue?vue&type=style&index=0&id=2b7b3c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b3c86",
  null
  
)

export default component.exports